var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.usePDFViewerOld &&
    _vm.usePDFViewerOld.active &&
    _vm.bytes.byteLength >= _vm.usePDFViewerOld.minByteLength
    ? _c(
        "div",
        [
          _c("app-pdf-viewer-old", {
            attrs: { bytes: _vm.bytes, customStyle: _vm.customStyle }
          })
        ],
        1
      )
    : _c("div", [
        _c(
          "div",
          { style: _vm.customStyle || {}, attrs: { shadow: "hover" } },
          [
            _vm.iframeSrc
              ? _c("iframe", {
                  staticClass: "iframe-container",
                  attrs: {
                    src: _vm.iframeSrc,
                    frameborder: "0",
                    allowfullscreen: "allowfullscreen",
                    height: _vm.height,
                    width: "100%"
                  }
                })
              : _vm._e()
          ]
        )
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6207e333", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6207e333","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppPDFViewer.vue
// module id = null
// module chunks = 